import { Box } from "@material-ui/core";
import { Grid } from "@mui/material";
import { lazy, useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import { selectCommonData } from "../../Store/Slices/CommonDataSlice";
import SelectInputAutoComplete from "../../Utils/HookForm/SelectInputAutoComplete";
import { mainContentStyle } from "./mainContentStyle";

const GeneralButton = lazy(
  () => import("../../Utils/GeneralButton/GeneralButton")
);
const SectionOne = () => {
  const hasWindow = typeof window !== "undefined";
  const [width, setWidth] = useState<any>(hasWindow ? window.innerWidth : null);
  const classes = mainContentStyle();
  const history = useHistory();
  const CommonData = useSelector(selectCommonData);
  const brands = CommonData.allCars;
  const [carModels, setCarModels] = useState<any[]>([]);
  const [carTypes, setCarTypes] = useState<any[]>([]);
  const [colors, setColors] = useState<any>([]);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [manufactureYears, setManufactureYears] = useState<any[]>([]);
  const [states] = useState<any>([
    {
      id: "NEW",
      text: "صفر",
    },
    {
      id: "USED",
      text: "کارکرده",
    },
  ]);
  const { t } = useTranslation("salesOrder");
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }
  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {}, [windowDimensions]);
  const imageRef = useRef(null);
  const {
    control,
    formState: { errors },
    getValues,
    setValue,
  } = useForm<any>({
    mode: "onBlur",
    reValidateMode: "onSubmit",
  });
  const handleResize = () => {
    setWidth(window.innerWidth);
  };
  //   useEffect(() => {
  //     const observer = new IntersectionObserver(
  //       ([entry]) => {
  //         const img: any = document.getElementById("img_main_id");
  //         if (entry.isIntersecting) {
  //           setIsOpen(true);
  //           if (!!img) {
  //             img.style.marginTop = "-400px";
  //           }
  //         } else {
  //           setIsOpen(false);
  //           if (!!img) {
  //             img.style.marginTop = "400px";
  //           }
  //         }
  //       },
  //       {
  //         threshold: 0.5, // 50% of the image is visible
  //       }
  //     );
  //     if (imageRef.current) {
  //       observer.observe(imageRef.current);
  //       const img: any = document.getElementById("img_main_id");
  //       if (!!img) {
  //         img.style.marginTop = "-100px";
  //       }
  //     }

  //     return () => {
  //       if (imageRef.current) {
  //         observer.unobserve(imageRef.current);
  //       }
  //     };
  //   }, []);
  useEffect(() => {
    window.addEventListener("resize", handleResize, false);
  }, []);
  useEffect(() => {}, [width]);
  useEffect(() => {
    setWidth(hasWindow ? window.innerWidth : null);
  }, [hasWindow]);
  const brandChange = (value: any) => {
    if (!!value) {
      setCarModels(
        !!value.carModels && value.carModels.length !== 0 ? value.carModels : []
      );
      if (!!getValues("carModel")) {
        setValue("carModel", null);
      }
      if (!!getValues("carType")) {
        setValue("carType", null);
      }
      if (!!getValues("color")) {
        setValue("color", null);
      }
      if (!!getValues("manufactureYear")) {
        setValue("manufactureYear", null);
      }
    }
  };
  const carModelChange = (value: any) => {
    if (!!value) {
      setCarTypes(
        !!value.carTypes && value.carTypes.length !== 0 ? value.carTypes : []
      );
      if (!!getValues("carType")) {
        setValue("carType", null);
      }
      if (!!getValues("color")) {
        setValue("color", null);
      }
      if (!!getValues("manufactureYear")) {
        setValue("manufactureYear", null);
      }
    }
  };
  const carTypeChange = (value: any) => {
    if (!!value) {
      let ctmy: any = [];
      value.carTypeManufactureYears.map((ct: any) => {
        ctmy.push({
          id: ct?.manufactureYearId,
          description: ct?.persianYear + "-" + ct?.miladiYear,
        });
      });
      // const prcItems = [...value.priceItems];
      // prcItems?.sort((a: any, b: any) => a.description.localeCompare(b.description));
      // setPriceItems(prcItems);
      if (!!getValues("color")) {
        setValue("color", null);
      }
      if (!!getValues("manufactureYear")) {
        setValue("manufactureYear", null);
      }
      const clrs = [...value.carTypeColors];
      clrs?.sort((a: any, b: any) => a.color.localeCompare(b.color));
      setColors(clrs);
      const trmClrs = [...value.carTypeTrimColors];
      trmClrs?.sort((a: any, b: any) => a.color.localeCompare(b.color));
      setManufactureYears(ctmy);
    }
  };
  return (
    <div style={{ width: "100%", position: "relative" }}>
      <Box
      // sx={{ display: { xs: "none", sm: "none", md: "block", lg: "block" } }}
      >
        <div
          ref={imageRef}
          id="img_main_id"
          className={`image-container ${isOpen ? "active" : ""}`}
        >
          <img
            alt="sec-1"
            width="100%"
            height="auto"
            src={process.env.PUBLIC_URL + "/images/sec-1.jpg"}
          />
        </div>
      </Box>
      <Box
        sx={{
          position: "absolute",
          top: { xs: "0", sm: "0", md: "200px", lg: "200px" },
          width: "100%",
          // marginTop: window.innerWidth * 0.001 + '%',
          // paddingBottom: { xs: '80px', sm: '80px', md: '50px', lg: '50px' },
        }}
      >
        <Box
          className="row justify-content-center w-100 ml-0 mr-0"
          sx={{
            marginTop: { xs: "0", sm: "0", md: "30px", lg: "30px" },
          }}
          style={{ direction: "rtl", position: "relative" }}
        >
          {/* <Box
            sx={{
              display: { xs: "block", sm: "block", md: "none", lg: "none" },
            }}
          >
            <div
              ref={imageRef}
              style={{
                position: "absolute",
                top: "-50px",
                left: "0",
                right: "0",
                zIndex: 0,
              }}
              className={`image-container ${isOpen ? "active" : ""}`}
            >
              <img
                alt="sec-1"
                id="img_main_id"
                width="100%"
                height="auto"
                src={process.env.PUBLIC_URL + "/images/sec-1.jpg"}
              />
            </div>
          </Box> */}
          <Grid item lg={6} md={6} sm={12} xs={12} style={{ zIndex: 999 }}>
            <Box
              sx={{
                width: "100%",
                display: { xs: "flex", sm: "flex", md: "block", lg: "block" },
              }}
            >
              <Box
                className="row w-50 justify-content-center ml-0 mr-0"
                sx={{
                  width: { xs: "auto", sm: "auto", md: "100%", lg: "100%" },
                  paddingLeft: {
                    xs: "0",
                    sm: "0",
                    md: "100px",
                    lg: "100px",
                  },
                }}
              >
                <Box
                  onClick={() => history.push("/prchs-cntnt")}
                  style={{ cursor: "pointer" }}
                  sx={{
                    fontWeight: 900,
                    fontSize: {
                      xs: "18px",
                      sm: "18px",
                      md: "28px",
                      lg: "28px",
                    },
                    color: "white",
                    width: "auto",
                    borderLeft: {
                      xs: "none",
                      sm: "none",
                      md: "5px solid white",
                      lg: "5px solid white",
                    },
                    paddingLeft: "15px",
                    paddingRight: "15px",
                  }}
                >
                  خریـــــــــدارم
                </Box>
              </Box>
              <Box
                className="row w-50 justify-content-center ml-0 mr-0"
                sx={{
                  width: { xs: "auto", sm: "auto", md: "100%", lg: "100%" },
                  paddingLeft: {
                    xs: "0",
                    sm: "0",
                    md: "100px",
                    lg: "100px",
                  },
                  marginTop: { xs: "0", sm: "0", md: "50px", lg: "50px" },
                }}
              >
                <Box
                  onClick={() => history.push("/sls-cntnt")}
                  style={{ cursor: "pointer" }}
                  sx={{
                    fontWeight: 900,
                    fontSize: {
                      xs: "18px",
                      sm: "18px",
                      md: "28px",
                      lg: "28px",
                    },
                    color: "white",
                    width: "auto",
                    borderLeft: {
                      xs: "none",
                      sm: "none",
                      md: "5px solid white",
                      lg: "5px solid white",
                    },
                    paddingLeft: "15px",
                    paddingRight: "15px",
                  }}
                >
                  فروشنــده‌ام
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid
            item
            lg={6}
            md={6}
            sm={12}
            xs={12}
            style={{ marginTop: "0px", textAlign: "left" }}
          >
            <Box
              sx={{
                width: { xs: "100%", sm: "100%", md: "80%", lg: "80%" },
                marginTop: { xs: "70px", sm: "70px", md: "0", lg: "0" },
                // position: {
                //   xs: "absolute",
                //   sm: "absolute",
                //   md: "static",
                //   lg: "static",
                // },
                // zIndex: 999,
              }}
              style={{
                backgroundColor: "rgb(206 206 206 / 63%)",
                backdropFilter: "blur(15px)",
                padding: "4px",
                boxShadow: "rgba(0, 0, 0, 0.58) 0px 1px 6px 1px",
                marginRight: "auto",
                marginLeft: "auto",
                borderRadius: "8px",
                right: "2px",
                left: "2px",
              }}
            >
              <div className="row w-100 ml-0 mr-0">
                <div className={classes.autoSlct}>
                  <SelectInputAutoComplete
                    name="brand"
                    options={brands}
                    label=""
                    placeholder={t("brand")}
                    control={control}
                    error={!!errors["brand"]}
                    classNames={classes.slct}
                    withoutShrink={true}
                    changeHandler={(value: string) => {
                      setValue("brand", value);
                      brandChange(value);
                    }}
                    helpText={errors["brand"]?.message}
                  />
                </div>
                <div className={classes.autoSlct}>
                  <SelectInputAutoComplete
                    name="carModel"
                    options={carModels}
                    label=""
                    disable={carModels.length === 0}
                    placeholder={t("carModel")}
                    control={control}
                    error={!!errors["carModel"]}
                    classNames={classes.slct}
                    withoutShrink={true}
                    changeHandler={(value: string) => {
                      setValue("carModel", value);
                      carModelChange(value);
                    }}
                    helpText={errors["carModel"]?.message}
                  />
                </div>
                <div className={classes.autoSlct}>
                  <SelectInputAutoComplete
                    name="carType"
                    options={carTypes}
                    disable={carTypes.length === 0}
                    label=""
                    placeholder={t("carType")}
                    control={control}
                    error={!!errors["carType"]}
                    classNames={classes.slctLast}
                    withoutShrink={true}
                    changeHandler={(value: any) => {
                      setValue("carType", value);
                      carTypeChange(value);
                    }}
                    helpText={errors["carType"]?.message}
                  />
                </div>
              </div>
              <div className="row w-100 ml-0 mr-0">
                <div className={classes.autoSlct}>
                  <SelectInputAutoComplete
                    name="manufactureYear"
                    options={manufactureYears}
                    disable={manufactureYears.length === 0}
                    label=""
                    placeholder={t("manufactureYear")}
                    control={control}
                    error={!!errors["manufactureYear"]}
                    classNames={classes.slct1}
                    withoutShrink={true}
                    changeHandler={(value: string) => {
                      setValue("manufactureYear", value);
                    }}
                    helpText={errors["manufactureYear"]?.message}
                  />
                </div>
                <div className={classes.autoSlct}>
                  <SelectInputAutoComplete
                    name="color"
                    options={colors}
                    disable={colors.length === 0}
                    label=""
                    placeholder={t("color")}
                    control={control}
                    error={!!errors["color"]}
                    classNames={classes.slct1}
                    withoutShrink={true}
                    changeHandler={(value: string) => {
                      setValue("color", value);
                    }}
                    helpText={errors["color"]?.message}
                  />
                </div>
                <div className={classes.autoSlct}>
                  <SelectInputAutoComplete
                    name="state"
                    options={states}
                    label=""
                    placeholder={t("mileageState")}
                    control={control}
                    error={!!errors["state"]}
                    classNames={classes.slct1Last}
                    withoutShrink={true}
                    changeHandler={(value: string) => {
                      setValue("state", value);
                    }}
                    helpText={errors["state"]?.message}
                  />
                </div>
              </div>
            </Box>
            <Box
              className="row justify-content-center w-100 ml-0 mr-0 pt-2"
              sx={{
                marginTop: { xs: "20px", sm: "5px", md: "46px", lg: "46px" },
              }}
            >
              <Grid item xs={8} sm={8} md={4} lg={3}>
                <GeneralButton
                  clicked={() => {
                    history.push({
                      pathname: "/purchase-order",
                      state: {
                        brand: getValues("brand"),
                        carModel: getValues("carModel"),
                        carType: getValues("carType"),
                        manufactureYear: getValues("manufactureYear"),
                        color: getValues("color"),
                        state: getValues("state")?.id,
                      },
                    });
                  }}
                  text="جستجو کنید"
                  btnType="General"
                  className={classes.mainBtn}
                />
              </Grid>
            </Box>
          </Grid>
        </Box>
      </Box>
    </div>
  );
};

export default SectionOne;
